{
  "title": "Announcements",
  "description": "School-wide and class notices.",
  "loading": "Loading…",
  "empty": {
    "title": "No announcements yet",
    "staffText": "Post one to reach a class — it lands in every member's inbox.",
    "readerText": "Announcements from your school and your classes appear here.",
    "filterTitle": "No announcements match these filters",
    "filterText": "Nothing here for this audience, class or search term. Clear the filters to see the whole feed."
  },
  "pinned": "Pinned",
  "pin": "Pin",
  "unpin": "Unpin",
  "audience": {
    "school": "Whole school",
    "class": "One class",
    "label": "Audience"
  },
  "filters": {
    "audience": "Audience",
    "all": "All",
    "class": "Class",
    "allClasses": "All classes",
    "search": "Search announcements",
    "searchPlaceholder": "Search title or text…",
    "clear": "Clear filters"
  },
  "card": {
    "by": "by {{name}}",
    "edited": "edited"
  },
  "compose": {
    "button": "New announcement",
    "title": "New announcement",
    "editTitle": "Edit announcement",
    "titleLabel": "Title",
    "titlePlaceholder": "What is this about?",
    "bodyLabel": "Message",
    "audienceLabel": "Who should see this",
    "classLabel": "Class",
    "selectClass": "Select a class",
    "pinLabel": "Pin to the top of the feed",
    "submit": "Publish",
    "save": "Save changes",
    "saving": "Saving…",
    "cancel": "Cancel",
    "teacherNote": "Teachers can post to the classes they teach; school-wide notices are an admin action.",
    "titleRequired": "Give the announcement a title.",
    "classRequired": "Pick the class this is for."
  },
  "actions": {
    "edit": "Edit",
    "delete": "Delete",
    "menu": "Announcement actions",
    "deleteConfirmTitle": "Delete this announcement?",
    "deleteConfirmBody": "It disappears from everyone's feed. This cannot be undone."
  },
  "toasts": {
    "created": "Announcement published.",
    "updated": "Announcement updated.",
    "deleted": "Announcement deleted.",
    "pinned": "Pinned to the top.",
    "unpinned": "Unpinned."
  },
  "latestCard": {
    "title": "Latest announcement",
    "empty": "No announcements yet.",
    "seeAll": "See all"
  }
}
